import { DealsTable } from '../../../components/Tables/DealsTable/DealsTable'
import React from 'react'
import { formatInteger } from '../../../utils/formatting'
import { DEAL_TABLE_KEY } from 'constants/tableQueryKeys'
import {
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { FBPage } from '../../../components/FbUI/Page/FBPage'
import { StageColorProvider } from 'components/SalesStage/StageColorContext'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { MetricCard } from 'components/FbUI/MetricCard'
import { PiHandshake } from 'react-icons/pi'

export function DealsPage() {
  const [totalDeals, setTotalDeals] = React.useState<number>()
  const { dealDetailPage } = useFeatureFlagService()

  const defaultColumnVisibility = dealDetailPage
    ? {
        deal: true,
        identifier: false,
        deal_name: false,
        predicted_annual_revenue: false,
        predicted_monthly_revenue: false,
        monthly_revenue_override: false,
        cc_doors_cnt: false,
      }
    : {
        identifier: false,
        predicted_annual_revenue: false,
        predicted_monthly_revenue: false,
        monthly_revenue_override: false,
        cc_doors_cnt: false,
      }

  const tableContent = (
    <DealsTable
      useReports={true}
      tableKey={DEAL_TABLE_KEY}
      defaultColumnVisibility={defaultColumnVisibility}
      showCompanyColumn
      setTotalRowsCount={setTotalDeals}
    />
  )

  return (
    <FBPage
      innerPageClassName="!bg-[#fefefe]"
      containerClassName="!bg-[#fefefe] !shadow-none"
    >
      <FBPageHeader>
        <FBPageTitleRow>
          <FBPageTitle className="!text-fg">Deals</FBPageTitle>
          <div className="ml-auto">
            <MetricCard
              icon={<PiHandshake size={18} />}
              label="Total Deals"
              value={totalDeals == null ? '—' : formatInteger(totalDeals)}
            />
          </div>
        </FBPageTitleRow>
      </FBPageHeader>
      <TableLinkStyleProvider variant="plain">
        <FBPageTableContainer className="flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]">
          {dealDetailPage ? (
            <StageColorProvider value="pipeline">
              {tableContent}
            </StageColorProvider>
          ) : (
            tableContent
          )}
        </FBPageTableContainer>
      </TableLinkStyleProvider>
    </FBPage>
  )
}
